module.exports = __webpack_public_path__ + "e65cb21b486ba5b92aa898540cda21fa.png";